<app-header></app-header>
<ion-content id="profile" class="gray-content-bg">
  <div>
    <app-profile-header [isDesktop]="isDesktop"></app-profile-header>
    <ion-grid>
      <app-profile-survey-card
        *ngIf="(surveyFeatureFlag$ | async) && isExternalUser"
        [surveyLink]="surveyLink$ | async"
      ></app-profile-survey-card>
      <ng-container>
        <div
          *ngIf="!isSuperUser && (isUpcDeprecated$ | async)"
          data-cy="profile-page-banner-text"
          class="profile-note"
        >
          <span>{{'i18n.profilePage.note.title' | translate}}</span>
          {{'i18n.profilePage.note.start' | translate}}
          <a data-cy="manage-alerts-link" (click)="openManageAlerts()"
            >{{'i18n.profilePage.note.link' | translate}}</a
          >
          {{'i18n.profilePage.note.end' | translate}}
        </div>
        <div
          *ngIf="!isSuperUser && (isUpcDeprecated$ | async) === false"
          data-cy="profile-page-banner-text"
          class="profile-note"
        >
          <span>{{'i18n.profilePage.upcNote.title' | translate}}</span>
          {{'i18n.profilePage.upcNote.start' | translate}}
          <a data-cy="preference-center-link" (click)="openUPC()"
            >{{'i18n.profilePage.upcNote.link' | translate}}</a
          >
          {{'i18n.profilePage.upcNote.end' | translate}}
        </div>
      </ng-container>
      <app-profile-contact-card
        (showToast)="openToast($event)"
        [isMobile]="isMobile"
        [contactForm]="contactForm"
        [userKind]="userKind"
        [ecUserId]="ecUserId"
        (setNewOriginal)="setNewOriginal()"
      >
      </app-profile-contact-card>
      <app-profile-security-card
        (showToast)="openToast($event)"
        [isMobile]="isMobile"
        [accountInfo]="profileAccount"
        [userKind]="userKind"
      >
      </app-profile-security-card>
      <app-profile-invite-new-user-card *ngIf="showInviteNewUserSection">
      </app-profile-invite-new-user-card>
      <app-custom-messages-card
        *ngIf="isCustomMessagesFlagEnabled && isMessagingAdmin$ | async"
        [customMessages]="this.customMessages"
        [userId]="this.ecUserId"
        (changeSort)="changeMessageListSort($event)"
        (downloadCustomerList)="downloadCustomerList($event)"
        (deleteCustomMessage)="deleteCustomMessage($event)"
      ></app-custom-messages-card>
      <app-profile-clear-data-card
        [isMobile]="isMobile"
      ></app-profile-clear-data-card>
      <p class="profile-delete-account" *appShowSplit="[deleteUserFlag]">
        {{'i18n.profilePage.deleteQuestion' | translate}}
        <a (click)="openDeleteAccountModal()"
          >{{'i18n.profilePage.deleteClickHere' | translate}}</a
        >
      </p>
      <div data-cy="profile-foot-notes" class="foot-notes">
        <p class="profile-privacy-policy">
          {{'i18n.profilePage.privacyPolicyText' | translate}}
          <a
            href="https://www.usfoods.com/content/dam/usf/EC/R4/documents/privacy.html"
            target="_blank"
          >
            {{'i18n.profilePage.privacyPolicyLink' | translate }}
          </a>
        </p>
        <p class="build-number">{{ buildNumber }}</p>
      </div>
    </ion-grid>
  </div>
  <app-footer></app-footer>
</ion-content>

<!-- Floating Tooltip for Profile -->
<div class="help-icon">
  <img
    data-cy="profile-page-open-help-modal-button"
    src="assets/icon/custom-help-tooltip.svg"
    (click)="openHelpModal()"
  />
</div>
